module.exports = __webpack_public_path__ + "img/DE03487.3bd2c3a0.png";